module.exports = __webpack_public_path__ + "a32dccf0690fc1399c3ea8707d87ff6f.jpg";